require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-savings-and-loan-specials.json") })
        }
      }, "path---es-savings-and-loan-specials");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-savings-and-loan-specials!./.cache/json/es-savings-and-loan-specials.json
// module id = 2615
// module chunks = 231608221292675